import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'era-lost-mode-confirmation-modal',
  templateUrl: './lost-mode-confirmation-modal.component.html',
  styleUrls: ['./lost-mode-confirmation-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FaIconComponent, ReactiveFormsModule],
})
export class LostModeConfirmationModalComponent {
  constructor(
    public readonly activeModal: NgbActiveModal,
    private readonly fb: UntypedFormBuilder
  ) {}

  public readonly lostModeForm = this.fb.group({
    message: '',
    footnote: '',
  });

  public enableLostMode(): void {
    const message: string = this.lostModeForm.get('message').value;
    const footnote: string = this.lostModeForm.get('footnote').value;
    const result = { message, footnote };
    this.activeModal.close(result);
  }
}
